import { appStore } from '@/store';
import { features } from '@/lib';

/**
 * @function shouldShowSCAPhoneConfirmationInterstitial
 * @description Opens the SCA Phone Confirmation Interstitial and
 * returns true if: SCA Phone Confirmation is required in the user
 * country AND the user is a guest signing up for a member account
 * AND we have not already confirmed the phone AND no phone confirmation
 * alert type has been set. Otherwise, returns false.
 * @returns {Boolean} show or do not show interstitial
 */
const shouldShowSCAPhoneConfirmationInterstitial = (): boolean => {
  const { form: formState } = appStore.getState();
  const { ui: uiActions } = appStore.getActions();

  if (features.isActive('shouldShowSCAPhoneConfirmation')) {
    const isSignup = formState.onboardOption.value === 'signup';

    if (isSignup && !formState.phone.meta?.isConfirmed) {
      uiActions.toggleIsFormSubmitting(false);
      uiActions.toggleIsPhoneConfirmationOpen(true);
      return true;
    }
  }

  return false;
};

export { shouldShowSCAPhoneConfirmationInterstitial };
